export const ACCEPT_VIDEO_RULES = 'video/mp4,video/x-m4v,video/*'
export const ACCEPT_IMAGES_RULES = 'image/*'

export const ACCEPT_DOCUMENT_RULES =
  '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
export const ACCEPT_PDF_RULES = '.pdf'
export const ACCEPT_PDF_TYPE = 'pdf'

export const ACCEPT_CSV_RULES = '.csv'

export const MAX_FILE_SIZE_MB = 20
export const NOT_ALLOWED_TYPES = [
  'jfif',
  'video/x-msvideo',
  'video/avi',
  'audio/ac3',
]
